import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService, AlertMessage } from 'src/app/services/alerts.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit, OnDestroy {
  message?: string;
  type?: string;
  alertSubscription: Subscription = new Subscription();

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.alertSubscription = this.alertService.alertState$.subscribe((alert: AlertMessage) => {
      this.message = alert.message;
      this.type = alert.type;
    });
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }

  clearAlert() {
    this.alertService.clearAlert();
  }
}
